// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { User } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconUser(props: any) {
    return <IconBase icon={User} {...props} />
  }

  export default IconUser
  